import { Button, Center, Text, VStack } from '@chakra-ui/react'
import { FC } from 'react'

type Props = {
  resourceName: string
  onRetry: () => Promise<unknown>
}

export const TopSectionLoadError: FC<Props> = ({ resourceName, onRetry }) => (
  <Center py="32px">
    <VStack spacing="12px">
      <Text color="gray.600">{resourceName}を取得できませんでした</Text>
      <Button size="sm" variant="outline" onClick={() => onRetry().catch(() => undefined)}>
        再読み込み
      </Button>
    </VStack>
  </Center>
)
